import React from 'react';
import { Logo } from './Logo';
import { Link } from 'react-router-dom';
import './LegalLayout.css';

interface LegalLayoutProps {
    title: string;
    lastUpdated?: string;
    children: React.ReactNode;
}

export const LegalLayout: React.FC<LegalLayoutProps> = ({ title, lastUpdated, children }) => {
    return (
        <div className="legal-page">
            <header className="legal-header">
                <div className="legal-header-content">
                    <Link to="/" className="legal-logo-link">
                        <Logo size="small" />
                    </Link>
                    <Link to="/" className="back-link">
                        &larr; Back to Home
                    </Link>
                </div>
            </header>

            <main className="legal-content-wrapper">
                <article className="legal-article">
                    <h1 className="legal-title">{title}</h1>
                    {lastUpdated && <p className="legal-updated">Last Updated: {lastUpdated}</p>}
                    <div className="legal-body">
                        {children}
                    </div>
                </article>
            </main>

            <footer className="legal-footer">
                <p>&copy; {new Date().getFullYear()} Nostavia Health. All rights reserved.</p>
            </footer>
        </div>
    );
};
